import { CaseStatus, CaseCopyStatus } from "src/types";

export function caseCopyStatusBackgroundColor(status: CaseCopyStatus): string {
  switch (status) {
    case CaseCopyStatus.COPYING:
      return "#FFF969";
    case CaseCopyStatus.FINISHED:
      return "#cbff69";
    case CaseCopyStatus.FAILED:
      return "#ffa869";
    default:
      return "grey";
  }
}

export function caseCopyStatusTextColor(status: CaseCopyStatus): string {
  switch (status) {
    case CaseCopyStatus.COPYING:
      return "#f3c024";
    case CaseCopyStatus.FINISHED:
      return "#149600";
    case CaseCopyStatus.FAILED:
      return "#960000";
    default:
      return "grey";
  }
}

export function caseStatusBackgroundColor(status: CaseStatus): string {
  switch (status) {
    case CaseStatus.PREPARING:
    case CaseStatus.CALCULATING:
      return "#FFF969";
    case CaseStatus.CREATION_FINISHED:
      return "#e6e6e6";
    case CaseStatus.CALCULATION_FINISHED:
      return "#cbff69";
    case CaseStatus.CALCULATION_FAILED:
    case CaseStatus.CREATION_FAILED:
      return "#ffa869";
    default:
      return "grey";
  }
}

export function caseStatusTextColor(status: CaseStatus): string {
  switch (status) {
    case CaseStatus.PREPARING:
    case CaseStatus.CALCULATING:
      return "#f3c024";
    case CaseStatus.CREATION_FINISHED:
      return "#8f8f8f";
    case CaseStatus.CALCULATION_FINISHED:
      return "#149600";
    case CaseStatus.CALCULATION_FAILED:
    case CaseStatus.CREATION_FAILED:
      return "#960000";
    default:
      return "grey";
  }
}
